export const LINK_SETTINGS_BANNER =
  "The link flow doesn't include a recipient list. Create your send, share the URL, and recipients fill in their own shipment details to start the send.";

export const LINK_DETAILS_SECTION_TITLE = 'Link details';

export const TITLE_FIELD_LABEL = 'Title';
export const TITLE_FIELD_HELPER = "For your reference only — recipients don't see this";

export const LIMITS_SECTION_TITLE = 'Limits';

export const EXPIRATION_TOGGLE_TITLE = 'Set expiration date';
export const EXPIRATION_TOGGLE_HELP =
  'Stops the campaign at the chosen time. You can also stop it whenever you want from the One Link Manager.';
export const EXPIRATION_FIELD_LABEL = 'Expiration date';
export const EXPIRATION_FIELD_PLACEHOLDER = 'Select date & time';

export const ON_HOLD_TOGGLE_TITLE = 'Put on hold';
export const ON_HOLD_TOGGLE_HELP =
  "Pause this link until a date you choose — recipients can't claim before then. The date must be in the future, up to one year out. You can change or clear it any time from the One Link Manager.";
export const ON_HOLD_FIELD_LABEL = 'On hold until';
export const ON_HOLD_FIELD_PLACEHOLDER = 'Select date';

export const REDEMPTION_TOGGLE_TITLE = 'Redemption limit';
export const REDEMPTION_TOGGLE_HELP =
  "Cap the total number of times this link can be claimed. Once the cap is hit, additional clicks see a 'no longer available' message.";
export const MAXIMUM_CLAIMS_LABEL = 'Maximum claims';

export const NOTIFICATIONS_SECTION_TITLE = 'Notifications';

export const SENDER_NOTIFICATIONS_TITLE = 'Send sender notifications';
export const SENDER_NOTIFICATIONS_HELP =
  'When ON, Imprint Engine generates email notifications with updates on every send. You can also check the status of each one within the One Link Manager.';

export const RECIPIENT_TRACKING_TITLE = 'Recipient tracking emails';
export const RECIPIENT_TRACKING_HELP =
  'When ON, the recipient receives tracking emails with status updates for this order';

export const ADVANCED_SECTION_TITLE = 'Advanced settings';

export const PASSWORD_TOGGLE_TITLE = 'Password protection';
export const PASSWORD_TOGGLE_HELP = 'Recipients will be asked to enter a password to access the send';
export const PASSWORD_FIELD_LABEL = 'Password';
export const PASSWORD_COPY_LABEL = 'Copy password';
export const PASSWORD_COPY_DISABLED_HINT = 'Set a password to enable copy';
export const PASSWORD_COPIED_HINT = 'Copied!';

export const DOMAINS_TOGGLE_TITLE = 'Email domain limiting';
export const DOMAINS_TOGGLE_HELP = 'Restrict access to only emails in your organization';
export const DOMAINS_FIELD_LABEL = 'Allowed domains';
export const DOMAINS_FIELD_PLACEHOLDER = 'Add a domain and press Enter';
export const DOMAINS_FIELD_HELPER = 'Add each domain and press Enter, e.g. acme.com';
export const invalidDomainHelper = (domain: string) => `"${domain}" is not a valid domain`;
export const DOMAIN_CHIP_EDIT_HINT = 'Click to edit';

export const DOMAINS_LOCKED_BY_TWO_FA = "Can't be combined with two-factor authentication — turn that off first";
export const APPLY_SENDER_DOMAIN_LABEL = "Apply sender's domain";

export const TWO_FA_TOGGLE_TITLE = 'Two-factor authentication';
export const TWO_FA_LOCKED_BY_DOMAINS = "Can't be combined with email domain limiting — turn that off first";
export const TWO_FA_TOGGLE_HELP = 'Recipients will be asked to verify their phone number or email address with a code';
export const TWO_FA_RECIPIENTS_WARNING = 'Add at least one recipient so they can receive verification codes';
export const TWO_FA_ADD_RECIPIENTS = 'Add recipients';
export const TWO_FA_MANAGE_RECIPIENTS = 'Manage';

export const FOR_YOUR_RECORDS_SECTION_TITLE = 'For your records';
export const INTERNAL_NOTES_LABEL = 'Internal notes';
export const INTERNAL_NOTES_HELPER = 'Visible to your team only — not shown to recipients';

export const GROUP_SHIPMENT_TOGGLE_TITLE = 'Group shipment';
export const GROUP_SHIPMENT_TOGGLE_HELP =
  "Orders that ship to an address-book location are flagged for the warehouse so they're held for one combined shipment instead of shipping individually.";

export const SHIPPING_SECTION_TITLE = 'Shipping';
export const ADDRESS_OPTIONS_LABEL = 'Address options';

export const ADDRESS_MODE_LABELS = {
  fixed_address: 'Fixed',
  recipient_decides: 'Recipient decides',
  from_list: 'Recipient decides from a list only',
};

export const ADDRESS_MODE_HELPERS = {
  fixed_address: "All gifts ship to one address you set — the recipient can't change it",
  recipient_decides: 'Recipient enters their own address or picks from a preset list of company addresses',
  from_list: 'Recipient will choose one of the addresses you select',
};

export const ENTER_FIXED_ADDRESS = 'Enter fixed address';
export const EDIT_FIXED_ADDRESS = 'Edit fixed address';
export const SELECT_ADDRESS_BOOK_OPTIONS = 'Select address book options';
export const EDIT_ADDRESS_BOOK_OPTIONS = 'Edit address book options';

export const FIXED_ADDRESS_REQUIRED_WARNING = 'Enter the delivery address all gifts will ship to';
export const MIN_TWO_ADDRESSES_WARNING = 'Pick at least 2 addresses so the recipient has a real choice';

export const REMOVE_FIXED_ADDRESS_LABEL = 'Remove address';
export const removeAddressLabel = (name: string) => `Remove ${name}`;

export const FIXED_ADDRESS_MODAL_TITLE = 'Enter delivery address';
export const FIXED_ADDRESS_MODAL_SUBTITLE =
  "All gifts ship here — the recipient can't change it, but can still pick gift options if available";
export const ADDRESS_SEARCH_PLACEHOLDER = 'Search address book…';
export const FIXED_ADDRESS_FIELD_LABELS = {
  company: 'Company name',
  address1: 'Address 1',
  address2: 'Address 2',
  city: 'City',
  state: 'State',
  zip: 'ZIP code',
  country: 'Country',
};
export const FIXED_ADDRESS_ZIP_INVALID_HELPER = 'Enter a valid ZIP code';
export const MODAL_CANCEL = 'Cancel';
export const MODAL_SAVE = 'Save';
export const MODAL_CLOSE_LABEL = 'Close';

export const SENDER_SECTION_TITLE = 'Sender';
export const SEND_ON_BEHALF_TITLE = 'Send on behalf of someone else';
export const SEND_ON_BEHALF_HELP =
  "If this option is ON your gifts will be sent on behalf of the person you choose. If it's OFF it will be sent on your behalf.";
